"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedItem = void 0;
const Photo_1 = require("./Photo");
const common_util_1 = require("../util/common-util");
const EventDto_1 = require("../dto/EventDto");
const EsText_1 = require("./EsText");
const CommonDto_1 = require("../dto/CommonDto");
class FeedItem {
    constructor(content) {
        this.id = 0;
        this.status = EventDto_1.FeedItemStatusDto.DRAFT;
        this.type = EventDto_1.FeedItemTypeDto.TXT;
        this.datePub = 0;
        this.title = "";
        this.signature = "";
        this.images = [];
        this.imageIds = [];
        this.content = content;
    }
    get hasImages() {
        return this.images.length > 0;
    }
    get lqImageUrl() {
        return this.hasImages ? this.images[0].lq.url : "";
    }
    get tqImageUrl() {
        return this.hasImages ? this.images[0].tq.url : "";
    }
    get hasSignature() {
        return !!this.signature;
    }
    static fromDto(feedItemDto) {
        const content = EsText_1.EsText.fromOptionalTextDto(feedItemDto.content);
        const feedItem = new FeedItem(content);
        feedItem.id = feedItemDto.id;
        feedItem.status = feedItemDto.status;
        feedItem.type = feedItemDto.type;
        if (feedItemDto.datePub) {
            feedItem.datePub = feedItemDto.datePub;
        }
        feedItem.title = feedItemDto.title;
        if (feedItemDto.signature) {
            feedItem.signature = feedItemDto.signature;
        }
        if (feedItemDto.images && feedItemDto.images.length > 0) {
            feedItemDto.images.forEach(photoDto => {
                const photo = Photo_1.Photo.fromDto(photoDto);
                feedItem.images.push(photo);
                feedItem.imageIds.push(photo.uploadId);
            });
        }
        return feedItem;
    }
    toDto() {
        const resultDto = {
            id: this.id,
            status: this.status,
            type: this.type,
            title: this.title
        };
        if (this.datePub > 0) {
            resultDto.datePub = this.datePub;
        }
        resultDto.type = EventDto_1.FeedItemTypeDto.TXT;
        if (this.content.notEmpty) {
            resultDto.content = this.content.toOptionalTextDto();
        }
        if (this.signature) {
            resultDto.signature = this.signature;
        }
        if (!common_util_1.isEmptyArray(this.imageIds)) {
            const photoIdsDto = this.imageIds.map(value => {
                const photoIdDto = { type: CommonDto_1.PhotoType.ID, uploadId: value };
                return photoIdDto;
            });
            resultDto.images = photoIdsDto;
        }
        return resultDto;
    }
}
exports.FeedItem = FeedItem;
